import ShowHide from '@/components/showHide';
import ToastStatusGlobal from '@/components/toastStatusGlobal';
import CompaniesService from '@/modules/company/services/companiesService';
import { InfoCopay } from '@/modules/copay/components/infoCopay/infoCopay';
import { ProceduresDescription } from '@/modules/copay/components/proceduresDescription/proceduresDescription';
import { ProceduresLabel } from '@/modules/copay/components/proceduresLabel/proceduresLabel';
import { useUsageStatementProcess } from '@/modules/copay/hooks/useUsageStatements/useUsageStatementProcess';
import { CopayService } from '@/modules/copay/services/copayService';
import { useHistoryNavigator, useHistoryParams } from '@/navigation';
import useCompany from '@/shared/hooks/useCompany/useCompany';
import { useRequestPaginatedList } from '@/shared/hooks/useRequestData/useRequestPaginatedList';
import { useRequestReadOne } from '@/shared/hooks/useRequestData/useRequestReadOne';
import React, { useMemo } from 'react';
import { Grid } from 'vkit/lib/context';

export const Details: React.FC = () => {
  const { usageStatementProcessId } = useHistoryParams();
  const { loading: processing, process } = useUsageStatementProcess();
  const navigate = useHistoryNavigator();
  const { toast } = ToastStatusGlobal();
  const { company } = useCompany();
  const {
    data: usageStatementProcess,
    loading: loadingUsageStatementProcess,
    loadData,
  } = useRequestReadOne({
    source: () => {
      return new CopayService().getOneUsageStatementProcess(usageStatementProcessId);
    },
  });
  const { data: companyParents } = useRequestPaginatedList({
    autoLoad: Boolean(company.salesforceParentId),
    source: () =>
      new CompaniesService().getCompanies({
        salesforceId: company.salesforceParentId || undefined,
      }),
  });

  const companyParentId = useMemo(() => {
    return company.salesforceParentId ? companyParents?.pop()?.id : company.id;
  }, [company.id, company.salesforceParentId, companyParents]);

  return (
    <Grid gap={16} column stretch>
      <InfoCopay
        usageStatementProcess={usageStatementProcess}
        loading={loadingUsageStatementProcess}
        refresh={loadData}
        companyParentId={companyParentId}
      />

      <ShowHide transition='slideToDown' visible={usageStatementProcess?.issueProcedures?.length}>
        <ProceduresDescription
          usageStatementProcess={usageStatementProcess}
          loading={loadingUsageStatementProcess}
          callbackSuccess={loadData}
        />
      </ShowHide>

      <ShowHide transition='slideToDown' visible={usageStatementProcess?.descriptionAddedAt}>
        <ProceduresLabel
          usageStatementProcess={usageStatementProcess}
          boxLoading={loadingUsageStatementProcess}
          buttonLoading={processing}
          callbackSuccess={async () => {
            if (usageStatementProcess?.id) {
              await process(usageStatementProcess.id, { approve: true });
            }
            toast('Feito', 'Rótulos enviados com sucesso.', 'success');
            navigate.push('/copaies');
          }}
        />
      </ShowHide>
    </Grid>
  );
};
